import { render, staticRenderFns } from "./ReportStandardSpecificationDialog.vue?vue&type=template&id=1147f69b&scoped=true&"
import script from "./ReportStandardSpecificationDialog.vue?vue&type=script&lang=js&"
export * from "./ReportStandardSpecificationDialog.vue?vue&type=script&lang=js&"
import style0 from "./ReportStandardSpecificationDialog.vue?vue&type=style&index=0&id=1147f69b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1147f69b",
  null
  
)

export default component.exports
import {QCard,QCardSection,QInnerLoading,QSpinnerGears,QTable,QSeparator,QCardActions,QBtn,ClosePopup} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QInnerLoading,QSpinnerGears,QTable,QSeparator,QCardActions,QBtn}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
